import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  ListContainer: {
    flex: 1,
  },
  ListLibelle : {
    fontSize: 18,
    color: '#0F579E',
    fontWeight: '700',
    textTransform: 'uppercase',
    marginTop: 24,
    marginBottom: 16,
    marginLeft: 16,
    marginRight: 16,
  },
  ListItemInRow: {
    flexDirection: 'row',
    padding:8,
    marginTop: 8,
    marginBottom: 24,
    marginRight: 16,
    marginLeft: 16,
    backgroundColor: 'white',
    borderRadius: 16,
    borderColor: '#f2f5f6',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'flex-start',

    shadowOffset:{  width: 6,  height: 12,  },
    shadowColor: 'black',
    shadowOpacity: 0.06,
    shadowRadius: 16,
    elevation: 2,
  },
  ListItemFont: {
    marginLeft: 32,
    fontSize: 18,
  },
  ListItemLogo: {
    width: 100,
    height: 100,
  },
});
